import React from "react";

import Modal from "react-responsive-modal";
import { Tooltip } from "react-tippy";
import UtilityService from "../../../services/UtilityService";

import * as Icon from "react-feather";

import "react-tippy/dist/tippy.css";

import { STATUSES } from "../../../constants/Tasks";

import SearchableDropdown from "../../common/searchable_dropdown/SearchableDropdown";
import UserService from "../../../services/UserService";
import ClientService from "../../../services/ClientService";
import TaskService from "../../../services/TaskService";
import EngagementService from "../../../services/EngagementService";

import TextFieldInput from "../../common/text_field_input/TextFieldInput";
import TextAreaField from "../../common/text_area_field/TextAreaField";
import Checkbox from "../../common/checkbox/Checkbox";
import WComponent from "../../common/WComponent";
import UserAssigner from "../../common/user_assigner/UserAssigner";
import DeleteConfirmationModal from "../../common/modal/confirmation_modal/ConfirmationModal";
import DateSelector from "../../common/date_selector/DateSelector";
import Loader from "../../common/loader/Loader";

import "./task-modal.css";
import "../../common/modal/modal.css";
import PermissionGate from "../../../permissions/permissionGate";
import RequiredLabel from "../../common/required_label";
import DescriptionField from "../../workflow/components/description_field/DescriptionField";

const { alert } = UtilityService;

class TaskModal extends WComponent {
	constructor() {
		super();
		this.state = {
			taskId: "new",
			engagementId: 0,
			clientId: 0,

			name: "",
			description: "",
			deadline: new Date().toDateString(),
			// duration: '',
			notes: "",
			notify: false,
			status: "pending",
			createdBy: 0,
			read: false,

			loading: false,
			show: false,

			selectedClientName: "",
			selectedStatus: "",

			assignedUsers: [],
			showDeleteConfirmation: false,
			description: "",

			// Sequential handoff
			step: 0,
			sequentialTasks: false,
			sentBackReason: "",
			showSendBack: false,
			sendBackDraft: "",
      
			queueForNextRecurring: false,
			assignedBy: null,
			selectedAssignedByName: "",

			// Header context and inline validation
			engagementName: "",
			createdByName: "",
			createdAt: null,
			formError: ""
		};
	}

	componentDidMount = () => {
		this.resetComponent();
	};

	componentDidUpdate = prevProps => {
		let { show } = this.props;

		if (prevProps.show !== show) {
			this.resetComponent();
		}
	};

	resetComponent = async () => {
		let { taskId, clientId, show } = this.props;
		// A new task is assigned by whoever creates it unless someone else is picked, the server applies the same default
		let { firstName, lastName } = UserService.getUserData();

		await this.update({
			loading: true
		});

		await this.update({
			// Toggles
			show,

			// Task Data
			taskId,
			clientId: clientId || 0,
			engagementId: 0,
			name: "",
			description: "",
			deadline: new Date().toDateString(),
			// duration: '',
			notes: "",
			status: "pending",
			notify: false,

			// Display Items
			selectedClientName: "",
			selectedStatus: "",

			assignedUsers: [],
			showDeleteConfirmation: false,

			step: 0,
			sequentialTasks: false,
			sentBackReason: "",
			showSendBack: false,
			sendBackDraft: "",
      
			queueForNextRecurring: false,
      assignedBy: null,
			selectedAssignedByName: `${firstName} ${lastName}`,

			engagementName: "",
			createdByName: "",
			createdAt: null,
			formError: ""
		});

		if (taskId !== "new") {
			await this.fetchTask();
		}

		if (clientId) {
			let client = await ClientService.fetchClient({ clientId });

			await this.update({
				selectedClientName: client.client.name
			});
		}

		await this.update({
			loading: false
		});
	};

	async fetchTask() {
		let { taskId } = this.state;

		let taskIdIntialState = 0;
		if (taskId === taskIdIntialState) {
			return;
		}

		try {
			let task = await TaskService.fetchTask({ taskId });

			let assignedUsers = task.task_users.map(tu => {
				let roleName = tu.Role ? tu.Role.name : "No Role";

				return {
					user_id: tu.user_id,
					role_id: tu.role_id,

					userName: `${tu.User.first_name} ${tu.User.last_name}`,
					roleName,
					should_notify: tu.notifications_only
				};
			});

			await this.update({
				// Task Data
				name: task.name,
				engagementId: task.engagement_id,
				clientId: task.client_id,

				description: task.description,
				deadline: task.deadline,
				// duration: task.duration,
				notes: task.notes,
				status: task.status,
				createdBy: task.created_by,
				notify: task.notify,
				read: task.read,

				// Display Items
				selectedClientName: task.Client ? task.Client.name : "",
				selectedStatus: STATUSES[task.status].name,

				assignedUsers,
				selectedAssignedByName: task.CreatedByUser ? `${task.CreatedByUser.first_name} ${task.CreatedByUser.last_name}` : "",

				step: task.step,
				sequentialTasks: !!(task.Engagement && task.Engagement.sequential_tasks),
				sentBackReason: task.sent_back_reason || "",
				showSendBack: false,
				sendBackDraft: "",

				engagementName: task.Engagement ? task.Engagement.name : "",
				createdByName: task.CreatedByUser ? `${task.CreatedByUser.first_name} ${task.CreatedByUser.last_name}` : "",
				createdAt: task.created_at || null
			});
		} catch (error) {
			console.log(error);
		}
	}

	updateTask = async () => {
		let { taskId, clientId, name, description, deadline, notes, status, notify, assignedUsers, assignedBy } = this.state;
		let { engagementId } = this.props;


		const missing = this.getMissingRequiredFields();
		if (missing.length) {
			await this.update({ formError: `Please fill: ${missing.join(", ")}` });
			alert({ type: "error", text: `Please fill: ${missing.join(", ")}` });
			return null;
		}

		alert({ type: "info", text: "Updating ..." });

		await this.update({
			loading: true
		});

		let task = null;

		try {
			task = await TaskService.update({ taskId, name, engagementId, clientId, description, deadline, notes, status, notify, assignedUsers, assignedBy });

			alert({ type: "success", text: "Updated Successfully!" });
		} catch (error) {
			console.log(error);
			alert({ type: "error", text: "Updated error ..." });
		}

		await this.update({
			loading: false
		});

		return task;
	};

	isValid = () => this.getMissingRequiredFields().length === 0;

	createTask = async () => {
		let { name, assignedUsers, clientId, description, deadline, notes, status, notify, queueForNextRecurring, assignedBy } = this.state;
		let { engagementId } = this.props;

		let created = false;

		const missing = this.getMissingRequiredFields();
		if (missing.length) {
			await this.update({ formError: `Please fill: ${missing.join(", ")}` });
			alert({ type: "error", text: `Please fill: ${missing.join(", ")}` });
			return created;
		}

		await this.update({
			loading: true
		});

		try {
			if (queueForNextRecurring) {
				created = await this.queueTaskForNextRecurring();
			} else {
				await TaskService.create({ name, engagementId, assignedUsers, clientId, description, deadline, notes, status, notify, assignedBy });

				created = true;

				alert({ type: "success", text: "Created Successfully!" });
			}
		} catch (error) {
			alert({ type: "error", text: "Create Error ..." });
		}

		await this.update({
			loading: false
		});

		return created;
	};

	queueTaskForNextRecurring = async () => {
		let { name, assignedUsers, description, deadline } = this.state;
		let { recurringEngagement, onRecurringEngagementUpdated } = this.props;

		let updatedRecurringEngagement = await EngagementService.queueRecurringEngagementItems({
			recurringEngagementId: recurringEngagement.id,
			tasks: [{ name, description, deadline, assignedUsers }]
		});

		if (!updatedRecurringEngagement) {
			alert({ type: "error", text: "Failed to save the task for the next recurring engagement." });
			return false;
		}

		alert({ type: "success", text: "Task saved! It will be added to the next recurring engagement." });

		if (onRecurringEngagementUpdated) {
			onRecurringEngagementUpdated(updatedRecurringEngagement);
		}

		return true;
	};

	isNewTask = () => {
		let { taskId } = this.state;
		return taskId === "new";
	};

	onChange = e => {
		let target = e.target;
		let value = target.type === "checkbox" ? target.checked : target.value;

		this.update({
			[target.name]: value,
			formError: ""
		});
	};

	// Formatting buttons for the description editor. mousedown keeps the selection inside the editor.
	applyFormat = (command, value = null) => event => {
		event.preventDefault();

		if (command === "createLink") {
			let url = window.prompt("Link URL");

			if (url) {
				document.execCommand("createLink", false, url);
			}

			return;
		}

		document.execCommand(command, false, value);
	};

	formatShortDate = value => {
		if (!value) {
			return "";
		}

		let date = new Date(value);

		if (isNaN(date.getTime())) {
			return "";
		}

		return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
	};

	onStatusSelect = status => {
		this.update({
			status: status.id,
			selectedStatus: status.name
		});
	};

	onClose = async ({ confirmed }) => {
		let task = null;

		if (confirmed) {
			if (this.isNewTask()) {
				let isCreated = await this.createTask();

				if (!isCreated) {
					return;
				}
			} else {
				task = await this.updateTask();
				if (!task) {
					return;
				}
			}
		}

		if (this.props.onClose) {
			// Completing a task in a sequential engagement wakes the next one server-side, tell the host to refetch.
			let refetch = !!(task && this.state.sequentialTasks && task.status === "done");

			this.props.onClose({ task, refetch });
		}
	};

	onDeadlineChange = date => {
		this.update({
			deadline: date
		});
	};

	onClientSelect = client => {
		this.update({
			clientId: client.id,
			selectedClientName: client.name
		});
	};

	deleteTask = async taskId => {
		const { engagementId } = this.state;

		try {
			await TaskService.update({ taskId, engagementId, isDeleted: true });
			this.resetComponent();
		} catch (error) {
			alert({ type: "error", text: "Task Delete Error!" });

			console.error(error);
		}
	};

	// Only the task currently holding the work, with a step before it, can be handed back.
	canSendBack = () => {
		let { sequentialTasks, step, status } = this.state;
		return !this.isNewTask() && sequentialTasks && step > 1 && ["ready", "in_progress"].includes(status);
	};

	onSendBackToggle = () => {
		this.update({ showSendBack: !this.state.showSendBack, sendBackDraft: "" });
	};

	onSendBackDraftChange = event => {
		this.update({ sendBackDraft: event.target.value });
	};

	onSendBackConfirm = async () => {
		let { taskId, sendBackDraft } = this.state;

		if (!sendBackDraft.trim()) {
			alert({ type: "error", text: "Please give a reason for sending this task back." });
			return;
		}

		await this.update({ loading: true });
		const previousTask = await TaskService.sendBack({ taskId, reason: sendBackDraft.trim() });
		await this.update({ loading: false });

		if (!previousTask) {
			alert({ type: "error", text: "Could not send this task back." });
			return;
		}

		alert({ type: "success", text: `Sent back to "${previousTask.name}".` });
		this.props.onClose({ task: previousTask, refetch: true });
	};

	onClickDelete = async () => {
		this.update({
			showDeleteConfirmation: true
		});
	};
	onClickDeleteConfirm = async ({ confirmed, proxyState }) => {
		await this.update({ showDeleteConfirmation: false });

		if (confirmed === false) {
			return;
		}

		const { taskId } = this.state;
		await this.deleteTask(taskId);
		this.onClose({ confirmed: true });
	};

	onAssignedUsersChanged = async ({ selectedUsers }) => {
		let { assignedUsers, assignedBy } = this.state;
		let newAssignedUsers = selectedUsers.slice();

		await this.update({
			assignedUsers: newAssignedUsers
		});

		// Unless one was picked, whoever adds a new person becomes the assigner, the server applies the same rule
		let addedNewPerson = newAssignedUsers.some(user => !assignedUsers.some(assignedUser => assignedUser.user_id === user.user_id));

		if (addedNewPerson && !assignedBy) {
			let { firstName, lastName } = UserService.getUserData();
			await this.update({ selectedAssignedByName: `${firstName} ${lastName}` });
		}
	};

	onAssignedBySelect = user => {
		this.update({
			assignedBy: user.id,
			selectedAssignedByName: user.name
		});
	};

	getMissingRequiredFields = () => {
		const { name, clientId, deadline, description, queueForNextRecurring } = this.state;
		const missing = [];
		if (!name?.trim()) missing.push("Task Name");
		// A queued task inherits its client from the engagement it materializes on
		if (!clientId && !queueForNextRecurring) missing.push("Client");
		if (!deadline) missing.push("Deadline");
		if (!description) missing.push("Description");
		return missing;
	};
    	
	onDescriptionChange = (html) => {
		this.update({ description: html });
	};
	
	render() {
		let {
			// Render state variables
			show,
			loading,

			// Data state variables
			taskId,
			name,
			description,
			deadline,
			createdBy,
			notify,
			assignedUsers,

			// Temp data render state variables
			selectedStatus,
			selectedClientName,
			selectedAssignedByName,
			engagementName,
			createdByName,
			createdAt,
			formError,

			step,
			sequentialTasks,
			sentBackReason,
			showSendBack,
			sendBackDraft,

			queueForNextRecurring
		} = this.state;
		let userData = UserService.getUserData();

		let isNew = this.isNewTask();
		let eyebrow = isNew ? "New task" : [engagementName, selectedClientName].filter(Boolean).join(" · ") || "Task";
		let saveLabel = isNew ? (queueForNextRecurring ? "Save for next engagement" : "Create") : "Update";

		return (
			<>
				<Modal
					open={show}
					onClose={() => this.onClose({ confirmed: false })}
					center
					showCloseIcon={false}
					classNames={{ modal: "task-modal-dialog", overlay: "task-modal-overlay" }}
				>
					<div className="task-modal tm">
						<div className="tm__hd">
							<div className="tm__hd__text">
								<div className="tm__eyebrow">
									<span>{eyebrow}</span>
									{sequentialTasks && step > 0 && (
										<span className="tm__step">
											<Icon.ArrowRight size={12} />
											Step {step} · sequential
										</span>
									)}
								</div>
								<div className="modal-title tm__title">{isNew ? name || "New Task" : name}</div>
								{!isNew && (
									<div className="tm__meta">
										{createdByName && (
											<span>
												Created by {createdByName}
												{createdAt ? ` on ${this.formatShortDate(createdAt)}` : ""}
											</span>
										)}
										<span>Task #{taskId}</span>
									</div>
								)}
							</div>
							<button type="button" className="tm__ib" aria-label="Close" onClick={() => this.onClose({ confirmed: false })}>
								<Icon.X size={18} />
							</button>
						</div>

						{loading && (
							<div className="tm__loading">
								<Loader />
							</div>
						)}

						{!loading && (
							<div className="tm__body">
								<div className="tm__col">
									{sentBackReason && (
										<div className="tm__banner tm__banner--amber task-modal__body__sent-back ft-task-sent-back">
											<Icon.CornerDownLeft size={15} />
											<div>
												<span className="tm__banner__t">Sent back: </span>
												{sentBackReason}
											</div>
										</div>
									)}

									{formError && (
										<div className="tm__banner tm__banner--red ft-task-form-error">
											<Icon.AlertCircle size={15} />
											<div>{formError}</div>
										</div>
									)}

									{!queueForNextRecurring && (
										<SearchableDropdown
											containerClass="tm__field"
											title={<RequiredLabel text="Client" />}
											placeholder="Select a client"
											onSelect={this.onClientSelect}
											type={"clients"}
											selectedName={selectedClientName}
											className="ft-task-client"
										/>
									)}

									{queueForNextRecurring && (
										<div className="tm__banner tm__banner--blue">
											<Icon.RefreshCw size={15} />
											<div>The client is inherited from the recurring engagement, so you do not need to select one.</div>
										</div>
									)}

									<TextFieldInput
										containerClass="tm__field"
										title={<RequiredLabel text="Task Name" />}
										name="name"
										placeholder="What needs to be done?"
										onChange={this.onChange}
										value={name}
										autoComplete="off"
										className="ft-task-name"
									/>

									<div className="tm__field tm__desc-wrap">
										<div className="tm__rte" role="toolbar" aria-label="Formatting">
											<button type="button" className="tm__rte__b" title="Bold" aria-label="Bold" onMouseDown={this.applyFormat("bold")}>
												<Icon.Bold size={14} />
											</button>
											<button type="button" className="tm__rte__b" title="Italic" aria-label="Italic" onMouseDown={this.applyFormat("italic")}>
												<Icon.Italic size={14} />
											</button>
											<button type="button" className="tm__rte__b" title="Underline" aria-label="Underline" onMouseDown={this.applyFormat("underline")}>
												<Icon.Underline size={14} />
											</button>
											<span className="tm__rte__sep" />
											<button type="button" className="tm__rte__b" title="Bulleted list" aria-label="Bulleted list" onMouseDown={this.applyFormat("insertUnorderedList")}>
												<Icon.List size={14} />
											</button>
											<button type="button" className="tm__rte__b" title="Link" aria-label="Link" onMouseDown={this.applyFormat("createLink")}>
												<Icon.Link size={14} />
											</button>
										</div>
										<DescriptionField label={<RequiredLabel text="Description" />} value={description} onChange={this.onDescriptionChange} inputClassName="ft-task-desc" />
									</div>

									<div className="tm__row2">
										<SearchableDropdown
											containerClass="tm__field"
											title="Status"
											placeholder="Select a status"
											onSelect={this.onStatusSelect}
											type={"taskStatuses"}
											selectedName={selectedStatus}
											showAll
											className="ft-task-status"
										/>

										<DateSelector
											containerClass="tm__field"
											title={<RequiredLabel text="Deadline" />}
											selectedDate={new Date(deadline)}
											onDateSelect={this.onDeadlineChange}
											dateFormat={"MMMM d, yyyy h:mm aa"}
											showTimeSelect={true}
											className="ft-task-deadline"
										/>
									</div>

									{(userData.userId === createdBy || isNew) && (
										<Checkbox
											containerClass="tm__check"
											title="Notify me when this task is completed"
											name="notify"
											checked={notify}
											onChange={this.onChange}
											className="ft-task-notify"
										/>
									)}

									{isNew && this.props.recurringEngagement && (
										<div className="tm__check task-modal__queue-recurring">
											<Checkbox
												title="Save for the next recurring engagement"
												name="queueForNextRecurring"
												checked={queueForNextRecurring}
												onChange={this.onChange}
												className="ft-task-queue-recurring"
											/>
											<Tooltip
												arrow
												position="top"
												title="This task will not be added to the current engagement. It will be saved on the recurrence schedule and automatically added to the next engagement generated by it. The client is inherited from that engagement, so you don't need to select one. Until then, you can view or remove it from the engagement's Repeat tab."
											>
												<Icon.Info className="task-modal__queue-recurring__info-icon" size={15} />
											</Tooltip>
										</div>
									)}

									{showSendBack && (
										<div className="tm__sendback task-modal__body__send-back ft-task-send-back">
											<div className="tm__sendback__t">Reason for sending back to step {Math.max(1, step - 1)}</div>
											<TextAreaField name="sendBackDraft" value={sendBackDraft} onChange={this.onSendBackDraftChange} className="ft-task-send-back-reason" />
											<div className="tm__sendback__a task-modal__body__send-back__actions">
												<button type="button" className="tm__btn tm__btn--sm ft-task-send-back-cancel" onClick={this.onSendBackToggle}>
													Cancel
												</button>
												<button type="button" className="tm__btn tm__btn--sm tm__btn--primary ft-task-send-back-confirm" onClick={this.onSendBackConfirm} disabled={loading}>
													Confirm send back
												</button>
											</div>
										</div>
									)}
								</div>

								<div className="tm__aside">
									<div className="tm__aside__h">Assigned users</div>

									<UserAssigner onChange={this.onAssignedUsersChanged} users={assignedUsers} showNotificationToggle showAvatars addTitle="Add a person" />
                   <SearchableDropdown
										containerClass="task-modal__body__input"
										title="Assigned By"
										onSelect={this.onAssignedBySelect}
										type={"users"}
										selectedName={selectedAssignedByName}
										selectEmptyOnClear={false}
										showAll
										className="ft-task-assigned-by"
									/>

									<div className="tm__legend">
										<Icon.Bell size={12} />
										Notify on = notifications only, the person is not expected to do the work.
									</div>

									{!isNew && (
										<div className="tm__kv">
											{engagementName && (
												<div className="tm__kv__r">
													<span className="tm__kv__k">Engagement</span>
													<span className="tm__kv__v">{engagementName}</span>
												</div>
											)}
											<div className="tm__kv__r">
												<span className="tm__kv__k">Client</span>
												<span className="tm__kv__v">{selectedClientName || "-"}</span>
											</div>
											{createdByName && (
												<div className="tm__kv__r">
													<span className="tm__kv__k">Assigned by</span>
													<span className="tm__kv__v">{createdByName}</span>
												</div>
											)}
											{createdAt && (
												<div className="tm__kv__r">
													<span className="tm__kv__k">Created</span>
													<span className="tm__kv__v">{this.formatShortDate(createdAt)}</span>
												</div>
											)}
										</div>
									)}
								</div>
							</div>
						)}

						<div className="tm__ft modal-footer">
							<PermissionGate resource="task" action="delete">
								{!isNew && (
									<button type="button" className="tm__btn tm__btn--icon tm__btn--danger ft-task-delete-btn" title="Delete task" aria-label="Delete task" onClick={this.onClickDelete}>
										<Icon.Trash2 size={16} />
									</button>
								)}
							</PermissionGate>
							{this.canSendBack() && (
								<PermissionGate resource="task" action="update">
									<button type="button" className="tm__btn ft-task-send-back-btn" onClick={this.onSendBackToggle} disabled={loading}>
										<Icon.CornerDownLeft size={15} />
										Send back
									</button>
								</PermissionGate>
							)}
							<span className="tm__ft__sp" />
							<PermissionGate resource="task" action="cancel">
								<button type="button" className="tm__btn ft-task-cancel-btn" onClick={() => this.onClose({ confirmed: false })}>
									Cancel
								</button>
							</PermissionGate>
							{isNew && (
								<PermissionGate resource="task" action="create">
									<button type="button" className="tm__btn tm__btn--primary ft-task-create-update-btn" onClick={() => this.onClose({ confirmed: true })} disabled={loading}>
										{saveLabel}
									</button>
								</PermissionGate>
							)}
							{!isNew && (
								<PermissionGate resource="task" action="update">
									<button type="button" className="tm__btn tm__btn--primary ft-task-create-update-btn" onClick={() => this.onClose({ confirmed: true })} disabled={loading}>
										{saveLabel}
									</button>
								</PermissionGate>
							)}
						</div>
					</div>
				</Modal>

				<DeleteConfirmationModal
					title="Delete Task?"
					warning="Are you sure you want to delete this task?"
					show={this.state.showDeleteConfirmation}
					onClose={this.onClickDeleteConfirm}
				/>
			</>
		);
	}
}

export default TaskModal;
